module.exports = __webpack_public_path__ + "img/6a1a0a4285e00d9d7112882c62f381ba.svg";